/**
 * OfflineBanner — the slim "you're offline, showing your last saved data"
 * strip a page shows when it fell back to services/offlineCache.js instead
 * of a live fetch. Deliberately not a modal or full-page state — the
 * content underneath is still real (if stale), so the page keeps rendering
 * it; this just discloses that it's stale.
 */

import { V2, Notice } from './JaiV2'
import { JAI_FONTS } from './JaiBrand'

export default function OfflineBanner({ cachedAt }) {
  const when = cachedAt
    ? new Date(cachedAt).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
    : null

  return (
    <Notice tone="warning" style={{ marginTop: 0 }}>You're offline — showing your last saved data{when ? ` (from ${when})` : ''}.</Notice>
  )
}
